import { Box, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'

const CustomTypography = (props) => {
    const textElementRef = useRef();
    const [hoverStatus, setHover] = useState(false);

    const compareSize = () => {
       const compare = textElementRef.current.scrollWidth > textElementRef.current.clientWidth;
        setHover(compare);
        
    };

    useEffect(() => {
        compareSize();
        window.addEventListener('resize', compareSize);
    });

    // remove resize listener again on "componentWillUnmount"
    useEffect(() => () => {
        window.removeEventListener('resize', compareSize);
    });

    const TypographyStyle = {
        fontFamily: "Gotham",
        textOverflow: "ellipsis", // Corrected typo
        whiteSpace: "nowrap",
        overflow: "hidden",
        minWidth: 0,
        ...props.sx
    };

    return (
        <>
            <Tooltip
                {...props?.component?.tooltip}
                title={props.title}
                interactive
                disableHoverListener={!hoverStatus}
            >
                <Typography ref={textElementRef} sx={TypographyStyle} {...props?.component?.typography}>{props.children}</Typography>
            </Tooltip>
        </>
    );
}

export default CustomTypography

/*
example to use:
<CustomTypography 
    title={project.name}
    component={{
        tooltip: {
            TransitionComponent: Zoom,
            TransitionProps: { timeout: 300 }
            sx:{
             backgroundColor:"yellow"
             }
            },
          typography:{
           sx:{
              backgroundColor:"yellow"
            }
          }    
        }}
>{project.name}</CustomTypography>
*/
